import { Link } from 'react-router-dom';
import { useSettings } from '../../context/SettingsContext';

export const Footer = () => {
  const { settings } = useSettings();

  const quickLinks = [
    { to: '/', label: 'Home' },
    { to: '/about', label: 'About' },
    { to: '/services', label: 'Services' },
    { to: '/projects', label: 'Projects' },
    { to: '/safety', label: 'Safety' },
    { to: '/careers', label: 'Careers' },
    { to: '/contact', label: 'Contact' },
  ];

  const services = [
    { to: '/services#commercial', label: 'Commercial' },
    { to: '/services#industrial', label: 'Industrial' },
    { to: '/services#residential', label: 'Residential' },
    { to: '/services#panels', label: 'Panel Upgrades' },
    { to: '/services#lighting', label: 'Lighting & Controls' },
    { to: '/services#ev-charging', label: 'EV Charging' },
  ];

  return (
    <footer className="bg-[#3D3A38] text-[#F5F1EC]" data-testid="footer">
      <div className="container-custom py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          
          {/* Brand */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3 mb-6">
              <img
                src="https://customer-assets.emergentagent.com/job_aozat-power/artifacts/19tmgxv4_image.png"
                alt="AOZAT"
                className="h-12 w-auto"
              />
              <span 
                className="text-sm tracking-[0.15em] uppercase text-[#B8A066]"
                style={{ fontFamily: 'Outfit, sans-serif' }}
              >
                Electrical
              </span>
            </div>
            <p className="text-sm leading-relaxed opacity-60 mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
              A division of Aozat General Contractors. Commercial, industrial & residential electrical services across the Greater Toronto Area.
            </p>
            <p className="text-lg font-medium text-[#B8A066]" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
              Licensed # 7018736
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 
              className="text-xs tracking-[0.2em] uppercase mb-6 opacity-60"
              style={{ fontFamily: 'Outfit, sans-serif' }}
            >
              Quick Links
            </h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm opacity-80 hover:opacity-100 hover:text-[#B8A066] transition-colors duration-300"
                    style={{ fontFamily: 'Outfit, sans-serif' }}
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 
              className="text-xs tracking-[0.2em] uppercase mb-6 opacity-60"
              style={{ fontFamily: 'Outfit, sans-serif' }}
            >
              Services
            </h4>
            <ul className="space-y-3">
              {services.map((service) => (
                <li key={service.to}>
                  <Link
                    to={service.to}
                    className="text-sm opacity-80 hover:opacity-100 hover:text-[#B8A066] transition-colors duration-300"
                    style={{ fontFamily: 'Outfit, sans-serif' }}
                  >
                    {service.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 
              className="text-xs tracking-[0.2em] uppercase mb-6 opacity-60"
              style={{ fontFamily: 'Outfit, sans-serif' }}
            >
              Contact
            </h4>
            <div className="space-y-4">
              <div>
                <p className="text-xs uppercase tracking-[0.15em] opacity-40 mb-1" style={{ fontFamily: 'Outfit, sans-serif' }}>Direct</p>
                <a 
                  href={`tel:${settings.phone}`} 
                  className="text-sm hover:text-[#B8A066] transition-colors duration-300"
                  style={{ fontFamily: 'Outfit, sans-serif' }}
                >
                  {settings.phone}
                </a>
              </div>
              <div>
                <p className="text-xs uppercase tracking-[0.15em] opacity-40 mb-1" style={{ fontFamily: 'Outfit, sans-serif' }}>Email</p>
                <a 
                  href={`mailto:${settings.email}`}
                  className="text-sm hover:text-[#B8A066] transition-colors duration-300"
                  style={{ fontFamily: 'Outfit, sans-serif' }}
                >
                  {settings.email}
                </a>
              </div>
              <div>
                <p className="text-xs uppercase tracking-[0.15em] opacity-40 mb-1" style={{ fontFamily: 'Outfit, sans-serif' }}>Office</p>
                <p className="text-sm opacity-80" style={{ fontFamily: 'Outfit, sans-serif' }}>
                  {settings.address}
                </p>
              </div>
              <div>
                <p className="text-xs uppercase tracking-[0.15em] opacity-40 mb-1" style={{ fontFamily: 'Outfit, sans-serif' }}>Hours</p>
                <p className="text-sm opacity-80" style={{ fontFamily: 'Outfit, sans-serif' }}>
                  {settings.business_hours}
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs opacity-40" style={{ fontFamily: 'Outfit, sans-serif' }}>
            &copy; {new Date().getFullYear()} Aozat Electrical. All rights reserved.
          </p>
          <p className="text-sm text-[#B8A066]" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
            A division of Aozat General Contractors
          </p>
          <div className="flex gap-6">
            <span className="text-xs opacity-40 cursor-pointer hover:opacity-80 transition-opacity duration-300" style={{ fontFamily: 'Outfit, sans-serif' }}>
              Privacy Policy
            </span>
            <span className="text-xs opacity-40 cursor-pointer hover:opacity-80 transition-opacity duration-300" style={{ fontFamily: 'Outfit, sans-serif' }}>
              Terms of Service
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};
